import { HttpTransportType, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';

import { type AppStore } from '../stories/Store/configureStore';
import * as Actions from '../stories/Store/signalRSlice';
import logger from './logger';

const hubConnection = new HubConnectionBuilder()
    .withUrl('/signalr', {
        skipNegotiation: false,
        transport: HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .configureLogging(process.env.REACT_APP_CONSOLE_LOG_ENABLED?.toLowerCase() === 'true'
        ? LogLevel.Information
        : LogLevel.None)
    .build();

hubConnection.onclose(function () {
    // logger.log('SignalR disconnected');
});

hubConnection.onreconnecting((err: unknown) => {
    logger.log('SignalR onreconnecting error', {
        error: err,
    });
}); 
// logger.log('SignalR starting middleware');

let serviceStarted = false;

export function handleSignalRMessage(store: AppStore, message: unknown) {
    const messageCandidate = message as Partial<Actions.SignalREvent> | null;
    if (
        !messageCandidate ||
        typeof messageCandidate.program_sk !== 'number' ||
        !Array.isArray(messageCandidate.actions)
    ) {
        logger.log('SignalR message ignored: invalid payload', {
            hasActions: Array.isArray(messageCandidate?.actions),
            payloadType: message === null ? 'null' : typeof message,
        });
        return;
    }

    store.dispatch(Actions.receiveRMessage(messageCandidate as Actions.SignalREvent));
}

export function getSignalRStreamUrl(action: { type?: unknown, url?: unknown }, programSk: number) {
    const streamUrl = typeof action.url === 'string' ? action.url.trim() : '';
    if (!streamUrl) {
        logger.log('SignalR stream change ignored: invalid URL', {
            actionType: action.type,
            programSk,
        });
        return null;
    }

    return streamUrl;
}

export function signalRStart(store: AppStore) {    
    if (!serviceStarted) {
        hubConnection.on('ReceiveMediaMessage', (message) => {
        // logger.log('SignalR received message', {
            //     message: message,
            // });
            handleSignalRMessage(store, message);
        });
        serviceStarted = true;
    }

    // logger.log('SignalR starting connector');

    if (hubConnection.state === HubConnectionState.Disconnected) {
        hubConnection.start().then(() => {
            // logger.log('SignalR connector started');
        });
    }
}

export default hubConnection;
